import { createSessionStorage, createStorage } from "./storage";

// Auth-related storage
export const authStorage = createStorage({ namespace: "medbillai-auth-state" });

// App download Web storage
export const downloadStorage = createStorage({
  namespace: "medbillai-downloads",
});

// User segmentation data storage
export const userSegmentationStorage = createSessionStorage({
  namespace: "medbillai-user-segmentation",
});

// Web to mobile modal storage
export const escalationModalStorage = createStorage({
  namespace: "medbillai-web-to-mobile-modal",
});

// Add other storage instances as needed
// export const someOtherStorage = createStorage({ namespace:
// "some-other-namespace" });
